var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-element-loading',{attrs:{"active":!_vm.appReady,"is-full-screen":"","text":(_vm.randomLoadingText + " ....")}})}
var staticRenderFns = []

export { render, staticRenderFns }